import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ResourceSelectField from '../../FormFields/ResourceSelectField';


export default function ResourceForm(props) {
  const {
    formField: {
      resource
    }
  } = props;

  return (
    <Box>
      <Typography variant="h6" gutterBottom textAlign="center">
        Seleccione el tipo de recurso a adherir
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ResourceSelectField name={resource.name} />
        </Grid>
      </Grid>
    </Box>
  );
} 